import Highcharts from 'highcharts/highstock'

import 'highcharts/modules/exporting'
import 'highcharts/modules/offline-exporting'
import 'highcharts/modules/full-screen'

Highcharts.setOptions({ accessibility: { enabled: false } })
